




















































































































































































import {
  defineComponent,
  reactive,
  SetupContext,
  ref,
  onUpdated,
} from '@nuxtjs/composition-api';
import { Swiper } from 'swiper';
export default defineComponent({
  props: {
    options: {
      type: Object,
      default: () => {},
    },
    isMiddle: {
      type: Boolean,
      default: false,
    },
    isSignIn: {
      type: Boolean,
      default: true,
    },
    isCenterLayout: {
      type: Boolean,
      default: false,
    },
    isTopic: {
      type: Boolean,
      default: false,
    },
    isLarge: {
      type: Boolean,
      default: false,
    },
    isFeed: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, _context: SetupContext) {
    // ボタン表示設定
    const isBeginning = ref(true);
    const isEnd = ref(true);
    const swiperRef: any = ref(null);

    // スワイパーのオプション設定
    const swiperOption = reactive({
      slidesPerView: 'auto',
      centeredSlides: true, // 中央に配置
      spaceBetween: 10,
      // スライドの横幅は大体の値
      breakpoints: {
        // 450: {
        //   spaceBetween: 10,
        // },
        560: {
          spaceBetween: 15,
        },
      },
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable: true,
      //   type: 'bullets',
      //   dynamicBullets: 'true',
      // },
      on: {
        afterInit: (swiper: Swiper) => {
          isBeginning.value = swiper.isBeginning;
          isEnd.value = swiper.isEnd;
        },
      },
      ...props.options,
    });

    // 【← →】の動き
    // クリックしたボタンが、
    // 左だったら、activIndex -1して左にスライド
    // 右だったら、activIndex ＋1して右にスライド
    const swiperSlide = (isLeft: boolean) => {
      const swiper = swiperRef.value?.$swiper;
      if (swiper) {
        swiper.slideTo(swiper.activeIndex + (isLeft ? -1 : 1));
      }
    };

    // 【← →】の表示状態更新処理
    const arrowRefresh = () => {
      const swiper = swiperRef.value?.$swiper;
      isBeginning.value = swiper.isBeginning;
      isEnd.value = swiper.isEnd;
    };

    onUpdated(() => {
      arrowRefresh();
    });

    return {
      arrowRefresh,
      swiperOption,
      isBeginning,
      isEnd,
      swiperRef,
      swiperSlide,
    };
  },
});
